import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";
import { LOGO_URL } from "../lib/config";

export default function PaymentCancelPage() {
  return (
    <div className="min-h-screen bg-fp-bg grid-bg flex items-center justify-center p-5" data-testid="payment-cancel-page">
      <div className="relative max-w-lg w-full p-10 rounded-3xl border border-white/10 bg-fp-surface/60 backdrop-blur-xl text-center">
        <img src={LOGO_URL} alt="" className="w-16 h-16 mx-auto" />
        <XCircle className="mx-auto mt-8 text-white/50" size={64} />
        <h1 className="mt-6 font-heading font-black text-3xl silver-gradient">Pagamento annullato</h1>
        <p className="mt-3 text-white/60">Nessun addebito è stato effettuato. Puoi riprovare quando vuoi.</p>
        <div className="mt-8 flex gap-3 justify-center flex-wrap">
          <Link to="/register" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-fp-cyan text-fp-bg font-heading font-bold tracking-wider uppercase text-sm hover:shadow-[0_0_25px_rgba(0,229,255,0.6)] transition-all">
            <ArrowLeft size={16} /> Riprova iscrizione
          </Link>
          <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-white/20 text-white hover:border-fp-cyan hover:text-fp-cyan font-heading font-bold text-sm uppercase tracking-wider transition-all">
            Home
          </Link>
        </div>
      </div>
    </div>
  );
}
